import { AboutSection } from "./AboutSection";
import { ContactSection } from "./ContactSection";
import { EventsSection } from "./EventsSection";
import { FormSection } from "./FormSection";
import { GallerySection } from "./GallerySection";
import { StatsCounterSection } from "./StatsCounterSection";
import { TestimonialSection } from "./TestimonialSection";
import { TrucksSection } from "./TrucksSection";
import { WhyUsSection } from "./WhyUsSection";

export const styles = {
  aboutBG: { backgroundImage: "url(/img/about.jpg)" },
  event1BG: { backgroundImage: "url(/img/events-1.jpg)" },
  event2BG: { backgroundImage: "url(/img/events-2.jpg)" },
  event3BG: { backgroundImage: "url(/img/events-3.jpg)" },
  reservationBG: { backgroundImage: "url(/img/reservation.jpg)" },
  iFrame: { border: 0, width: "100%", height: "350px" },
};
export type ITruckData = {
  imgUri: string;
  social: {
    twitter: string;
    facebook: string;
    instagram: string;
  };
  name: string;
  tags: string[];
  description: string;
};
export const TRUCK_DATA: ITruckData[] = [
  {
    imgUri: "/img/chefs/chefs-1.jpg",
    social: {
      twitter: "https://twitter.com/7starrwings",
      facebook: "https://facebook.com/7starrwings",
      instagram: "https://instagram.com/7starrwings",
    },
    name: "7Starr Wings",
    tags: ["American Southern Comfort Food"],
    description: "Velit aut quia fugit et et. Dolorum ea voluptate vel tempore",
  },
];

export const MainSection = () => (
  <main id="main">
    <AboutSection />

    <WhyUsSection />

    <StatsCounterSection />

    <GallerySection />

    <TestimonialSection />

    <EventsSection />

    <TrucksSection />

    <FormSection />

    <GallerySection />

    <ContactSection />
  </main>
);
